/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_Play_StoreInputs */

const en_us2_onboarding_how_heard_play_store = /** @type {(inputs: Onboarding_How_Heard_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store`)
};

const pt_br2_onboarding_how_heard_play_store = /** @type {(inputs: Onboarding_How_Heard_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store`)
};

const es_419_onboarding_how_heard_play_store = /** @type {(inputs: Onboarding_How_Heard_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store`)
};

const pt_pt2_onboarding_how_heard_play_store = /** @type {(inputs: Onboarding_How_Heard_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store`)
};

const fr_fr2_onboarding_how_heard_play_store = /** @type {(inputs: Onboarding_How_Heard_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store`)
};

const de_de2_onboarding_how_heard_play_store = /** @type {(inputs: Onboarding_How_Heard_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store`)
};

const it_it2_onboarding_how_heard_play_store = /** @type {(inputs: Onboarding_How_Heard_Play_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store`)
};

/**
* | output |
* | --- |
* | "Play Store" |
*
* @param {Onboarding_How_Heard_Play_StoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_play_store = /** @type {((inputs?: Onboarding_How_Heard_Play_StoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_Play_StoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_play_store(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_play_store(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_play_store(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_play_store(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_play_store(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_play_store(inputs)
	return en_us2_onboarding_how_heard_play_store(inputs)
});
export { onboarding_how_heard_play_store as "onboarding.how_heard.play_store" }